import './DevloperPage.css';
import UploadAllJobDetails from  '../jobsite/Components/UploadAllJobDetails.js';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../Resume Components/Pages/Login and Sign UP/api.js';
let DevloperPage=(props)=>{
    let  navigate = useNavigate();
    let [changepass, setchangepass]= useState(null); 
    let [photo, setphoto]=useState(null);
    let [gotdevphoto, setgotdevphoto]=useState(null);
    let getdevloperdet = async()=>{
        const resp = await api.get('/getdevloperdetails.php');
        setgotdevphoto(resp.data.data);
         
    }
    useEffect(()=>{
        let login = localStorage.getItem("devlogin");
        if(login===null){
            navigate("/Devloper-log-in-page");
        }
        getdevloperdet();
    });
    
   let logouthandel=()=>{
        localStorage.setItem("devlogin", "");
        localStorage.setItem("loginStatusdev", "Devloper loggedout successfully");
        localStorage.setItem("devtoken" , "");
        navigate("../Devloper-log-in-page");
   
    }
    let devloperpassupdate=()=>{
        document.querySelector(".devupdatepasscont").style.display="block";

    } 
    let submitupdatepassword=async(e)=>{
        e.preventDefault();
        let passformdata= new FormData();
        passformdata.append('devpass', changepass);
        const resp = await api.post('/updatedevloperpassword.php', passformdata);
        props.Successandrerrorfun(resp.data.result, "");


    }
    let unhidechangephoto=()=>{
        document.querySelector(".changephotoconttt").style.display="block";
    }
    let changedevphoto=async(e)=>{
        e.preventDefault();
        console.log(photo);
        let photoform = new FormData();
        photoform.append("photo", photo);
        const resp = await api.post("/updatephoto.php", photoform);
        props.Successandrerrorfun(resp.data.result, "");
        getdevloperdet();
    }
    return( 
        <div className='devlopermaincont'> 
             <h2 className='devpnlhead'>Devloper Panel 
                <span className='imgcontt'><img className='devpic' src={'https://makeeasyway.in/resumeData/'+gotdevphoto?.photo} alt='devpic'/>
                    <div className='hoveredcompcont'>
                        <span className='changephotocont'><i onClick={unhidechangephoto} title='ChangePhoto' className='bx bx-edit-alt' style={{fontSize:"30px", cursor:"pointer"}}></i></span>
                        <img className='devpicfill' src={'https://makeeasyway.in/resumeData/'+gotdevphoto?.photo} alt='devpic'/>
                        <p className='devname sss'>{gotdevphoto?.name}</p>
                        <p className='updatepass sss' onClick={devloperpassupdate}>Change password</p>
                        <p className='logoutbtn sss' onClick={logouthandel}>Logout</p>
                     
                    </div>
                
                
                </span>
                
            </h2>
            <div style={{display:"none"}} className='devupdatepasscont'>
                <p className='devupdtpsshed'>Devloper Update password</p>
                <form className='devupdtpssformcont' onSubmit={submitupdatepassword}>
                    <input type='text' onChange={(e)=>{setchangepass(e.target.value)}} placeholder='New Password'/>
                    <input type='submit'/>

                </form>
            </div>
            <div style={{display:"none"}} className='changephotoconttt'>
                <p className='changephotohead'>Change Devloper Photo</p>
                <form onSubmit={changedevphoto} className='photoupdatecont'>
                    <input type='file' onChange={(e)=>{setphoto(e.target.files[0])}}/>
                    <input type='submit'/>
                </form>

            </div>
            <UploadAllJobDetails Successandrerrorfun={props.Successandrerrorfun}/> 
        </div> 
    );
}
export default DevloperPage;